export default "__VITE_ASSET__2Dd_YMe0__"